import React, { useState } from "react";
import InputMask from "react-input-mask";
import createTicket from "../../services/jiraService";
import Select from "../../components/CustomSelect/Select"; // Importar o componente Select
import "./FormWebHook.css";

function FormWebHook() {
  const [razaoSocial, setRazaoSocial] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [urlDestino, setUrlDestino] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [ambiente, setAmbiente] = useState('Homologação'); // Novo estado para o campo Ambiente
  const [responseMessage, setResponseMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [submited, setSubmited] = useState(false);

  const resetForm = () => {
    setRazaoSocial('');
    setCnpj('');
    setUrlDestino('');
    setApiKey('');
    setAmbiente('Homologação'); // Resetar o campo Ambiente
    setResponseMessage('');
  };

  const closeMsg = () => {
    setSubmited(false);
    resetForm();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!sending) {
      const ticketData = {
        'razao_social': razaoSocial,
        'cnpj': cnpj,
        'url_post': urlDestino,
        'api_key': apiKey,
        'ambiente': ambiente, 
        'tipo_problema': 'Task',
        'tipo_ticket': 'webhook',
      };
  
      setSending(true)
  
      try {
        const response = await createTicket(ticketData);
        if (response.status === 201) {
          setResponseMessage(
            `Ticket criado com sucesso. Ticket Key: ${response.data.ticket_key}`
          );
        } else {
          setResponseMessage(
            `Falha ao criar ticket. Status Code: ${response.status}`
          );
        }
      } catch (error) {
        setResponseMessage(
          `Erro ao criar ticket: ${
            error.response ? error.response.data : error.message
          }`
        );
      } finally {
        setSending(false)
        setSubmited(true);
      }
    }
  };

  return (
    <div className="form-integration">
      {!submited && (
        <header className="form-integration-header">
          <h1>Integração com WebHook</h1>
        </header>
      )}

      {!submited && (
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="razaoSocial">Razão Social / Nome Fantasia</label>
            <input
              type="text"
              name="razaoSocial"
              className="razao-social-input"
              placeholder="Insira a Razão Social / Nome Fantasia"
              value={razaoSocial}
              onChange={(e) => setRazaoSocial(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="cnpj">CNPJ</label>
            <InputMask
              type="text"
              name="cnpj"
              className="cnpj-input"
              placeholder="Insira o CNPJ"
              mask="99.999.999/9999-99"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="urlDestino">URL de Destino (POST)</label>
            <input
              type="text"
              name="urlDestino"
              className="url-destino-input"
              placeholder="Insira o nome"
              value={urlDestino}
              onChange={(e) => setUrlDestino(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="apiKey">API-KEY</label>
            <input
              type="text"
              name="apiKey"
              className="api-key-input"
              placeholder="Insira o API-KEY"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="ambiente">Ambiente</label>
            <Select
              options={[
                { value: 'Homologação', label: 'Homologação' },
                { value: 'Produção', label: 'Produção' }
              ]}
              onChange={(option) => setAmbiente(option.value)}
              placeholder="Selecione o Ambiente"
            />
          </div>

          <div className={`submit-btn ${sending ? 'loading' : ''}`}>
            <button type="submit">Solicitar</button>
          </div>
        </form>
      )}
      {submited && (
        <div className="wrapper-response">
          <span onClick={closeMsg}></span>
          <p>{responseMessage}</p>
        </div>
      )}
    </div>
  );
}

export default FormWebHook;